import { ThemeProvider } from '@ori-ui/mui';
import { TestIdProvider } from '@ori/testid-generator';
import i18next from 'i18next';
import type { VFC } from 'react';
import { I18nextProvider } from 'react-i18next';

import { BubbleGroup } from './components';
import type { TranslationsProviderResponse } from './providers';

interface AppProps {
  tenant: string;
  isECatalogue: boolean;
  translations: TranslationsProviderResponse;
}

export const App: VFC<AppProps> = ({ tenant, translations, isECatalogue }) => {
  if (!tenant) {
    throw new Error('Missing config values!');
  }

  i18next.init({
    lng: 'default',
    resources: {
      default: {
        translation: translations,
      },
    },
    keySeparator: '::',
  });

  return (
    <ThemeProvider
      enableCacheProvider
      cacheKey="basket-bubble"
    >
      <I18nextProvider i18n={i18next}>
        <TestIdProvider
          team="Checkout"
          project="basket-bubble"
        >
          <BubbleGroup isECatalogue={isECatalogue} />
        </TestIdProvider>
      </I18nextProvider>
    </ThemeProvider>
  );
};
